/**
 * Pay 页面公共配置
 * 所有品牌共享的文案和资源
 * 与 en.json 不完全匹配（格式不同），保持为固定值
 */

import { t } from '@/i18n/utils'

export const commonTexts = {
  get tips() { return t('paymentTips') },
  get tip1() { return t('paymentTip1') },
  get tip2() { return t('paymentTip2') },
  get tip3() { return t('paymentTip3') },
  get coins() { return t('Coins') },
} as const
